import React, { useState } from 'react';
import { FeedbackForm, CONTACT_SUPPORT, SUPPORT_REQUEST_ID } from 'domain/shared/oneStop';
import { Button, LoaderSize, Loading } from 'framework/ui/mui-builder';
import Box from '@mui/material/Box';

type ErrorBoundarySupportActionProps = {
  description: string;
};

const ErrorBoundarySupportAction = ({ description }: ErrorBoundarySupportActionProps) => {
  const [isSupportFormOpen, setIsSupportFormOpen] = useState(false);
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);

  const loader = (
    <Box
      role="status"
      aria-hidden="true"
      sx={{
        position: 'relative',
        width: { xs: '1em', md: '17px' },
        height: { xs: '1em', md: '17px' },
        marginRight: { md: '11px' },
      }}
    >
      <Loading size={LoaderSize.Small} />
    </Box>
  );

  return (
    <>
      <Button onClick={() => setIsSupportFormOpen(true)} sx={{ display: 'inline-flex', alignItems: 'center' }}>
        Contact support
        {isLoaderVisible ? loader : null}
      </Button>
      {isSupportFormOpen && (
        <FeedbackForm
          formId={SUPPORT_REQUEST_ID}
          formTitle={CONTACT_SUPPORT}
          setIsLoaderVisible={setIsLoaderVisible}
          closeFeedbackForm={() => setIsSupportFormOpen(false)}
          defaultValues={{
            subject: 'Unexpected error in DaVinci frontend',
            description,
          }}
        />
      )}
    </>
  );
};

export default ErrorBoundarySupportAction;
